import { useState, useRef, useEffect } from "react";
import FilterSection from "./filterSection";
import "./filterPanel.css";
import { AttributeGroup, Criteria, Filter } from "../../models/category";
import { Form } from "react-bootstrap";
import Fuse from "fuse.js";

const FilterPanel: React.FC<{
  filter: Filter;
  onChange: (value: {
    name: string;
    value: number | number[] | string | boolean;
    checked?: boolean;
  }) => void;
  index: number;
  criteria: Criteria;
}> = (props) => {
  const compareFn = (
    a: Fuse.FuseResult<AttributeGroup>,
    b: Fuse.FuseResult<AttributeGroup>
  ) => {
    return a.refIndex < b.refIndex ? -1 : 1;
  };
  const fuseOptions: Fuse.IFuseOptions<AttributeGroup> = {
    keys: ["name", "title", "values"],
    fieldNormWeight: 1,
    useExtendedSearch: true,
  };
  const [hittedAttributes, setHittedAttributes] = useState<string[]>([]);
  const searchAttribute = (keyword: string) => {
    const fuse = new Fuse(
      props.filter.attributes.map((obj) => ({ ...obj })),
      fuseOptions
    );
    const result = fuse.search(`'${keyword}`).sort(compareFn);
    const attributes = result.map((data) => data.item);
    const matchedAttributes: string[] = [];
    attributes.forEach((attribute) => {
      const valueFuser = new Fuse(attribute.values);
      const values = valueFuser.search(`'${keyword}`).map((data) => data.item);
      if (values.length > 0) {
        attribute.values = values;
        matchedAttributes.push(attribute.name);
      }
    });
    setHittedAttributes(matchedAttributes);
    return attributes;
  };

  const [attributes, setAttributes] = useState(props.filter.attributes);
  const handleOnlyInStockChange = (event: any) => {
    const checked = event.target.checked;
    props.onChange({
      name: "inStockOnly",
      value: checked,
    });
  };

  useEffect(() => {
    let initialAttributes = props.filter.attributes;
    if (props.criteria.keyword !== "") {
      initialAttributes = searchAttribute(props.criteria.keyword);
    }
    setAttributes(initialAttributes);
  }, [props.filter.attributes]);

  const handleCheckBoxChange = (event: any) => {
    const value = event.target.value;
    const name = event.target.name;
    const checked = event.target.checked;
    props.onChange({
      name,
      value,
      checked,
    });
  };

  const keywordInputRef = useRef<HTMLInputElement>(null);
  const handleSearchAttribute = (event: any) => {
    event.preventDefault();
    const keyword = keywordInputRef.current!.value;
    props.onChange({
      name: "keyword",
      value: keyword,
    });
    if (keyword.trim().length === 0) {
      setAttributes(props.filter.attributes);
      setHittedAttributes([]);
      return;
    }
    const result = searchAttribute(keyword);
    setAttributes(result);
  };

  return (
    <>
      <section className="filter-panel-container">
        <div className="panel-body filter-panel-default">
          <Form
            className="filter-panel-search-form"
            onSubmit={(e) => e.preventDefault()}
          >
            <Form.Control
              className="filter-panel-search"
              type="search"
              placeholder="Search Attributes"
              size="sm"
              ref={keywordInputRef}
              defaultValue={props.criteria.keyword}
              onChange={handleSearchAttribute}
            />
          </Form>
        </div>
        <div className="panel-body filter-panel-default">
          <Form
            className="filter-panel-search-form"
            onSubmit={handleSearchAttribute}
          >
            <Form.Check
              type="checkbox"
              label="In Stock Only"
              onChange={handleOnlyInStockChange}
              checked={props.criteria.inStockOnly}
            />
          </Form>
        </div>
        {attributes.map((attribute, n) => {
          const isCollapsed = !(
            n === 0 ||
            Object.keys(props.criteria.attributes).some(
              (a) => a === attribute.name
            ) ||
            hittedAttributes.some((a) => a === attribute.name)
          );
          return (
            <FilterSection
              title={attribute.title}
              isCollapsed={isCollapsed}
              key={`${attribute.name}-${n}`}
            >
              {attribute.values.map((item, i) => {
                let checked = false;
                if (
                  props.criteria.attributes &&
                  props.criteria.attributes[attribute.name] &&
                  props.criteria.attributes[attribute.name].some(
                    (v) => v === item
                  )
                ) {
                  checked = true;
                }
                return (
                  <div
                    className={`filter-panel-section ${!!item && item.length>25?"mt-1 mb-2":""}`}
                    key={`${attribute.name}-${n}-${i}`}
                  >
                    <span className="filter-checkbox">
                      <input
                        type="checkbox"
                        id={`filter-attr-checkbox-${attribute.name}-${n}-${i}`}
                        name={attribute.name}
                        value={item}
                        onChange={handleCheckBoxChange}
                        checked={checked}
                      />
                    </span>
                    <label
                      htmlFor={`filter-attr-checkbox-${attribute.name}-${n}-${i}`}
                    >
                      {item}
                    </label>
                  </div>
                );
              })}
            </FilterSection>
          );
        })}
      </section>
    </>
  );
};

export default FilterPanel;
